/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const data = {
    header_data: {
        title: 'Get to Know Our Family of Brands',
        listItem: [
            {
                item: 'OUR STORY',
                href: '/about-us-company-overview',
            },
            {
                item: 'SOCIAL AND ENVIRONMENTAL PRACTICES',
                href: '/social-and-environmental-practices',
            },
            {
                item: 'INVESTOR RELATIONS',
                href: '/investor.1800flowers.com',
            },
            {
                item: 'FAMILY OF BRANDS',
                href: '/our-family-of-brands',
            },
            {
                item: 'CONTACT US',
                href: '/contact-us',
            },

        ],
    },
    Page_Content: {
        buttonText: 'START SHOPPING',
        OurBrandsHarryanddavid: [
            {
                img: 'aboutus_flowers',
                logo: 'flowers',
                description: 'From truly original designs to exclusive signature collections, as well as beautiful plants for every occasion, 1-800-Flowers.com has been delivering smiles in every imaginable way for more than 40 years. The world\'s leading florist offers the best of both worlds: exquisite, florist-designed arrangements individually created by some of the nations top floral artists and hand-delivered the same day, and spectacular flowers shipped overnight "Fresh From Our Growers™".',
                href: '/1-800-flowers-home',
            },
            {
                img: 'aboutus_harryanddavid',
                logo: 'harryanddavid',
                description: 'From our juicy, handpicked Royal Riviera® Pears to our proprietary blend of sweet, smooth chocolate and everything in between, you’ll find the that difference is in the details and in how Harry & David has handpicked, packed, and crafted the finest gourmet delights using only premium ingredients since 1934.',
                href: '/1-800-flowers-home',
            },
        ],

        OurBrandsAboutusWolferman: [
            {
                img: 'aboutus_wolferman',
                logo: 'wolferman',
                description: 'Since 1888, Wolferman’s has remained a proud purveyor of gourmet breads and pastries, honoring our time-tested recipes with only premium ingredients, from our famous, super-thick English muffins to our indulgent cakes and pies handcrafted to perfection.',
                href: '/1-800-flowers-home',
            },
        ],
        OurBrandsAboutusFruitbouquetsv2: [
            {
                img: 'aboutus_fruitbouquets-v2',
                logo: 'fruitbouquets',
                description: 'Delicious, carved fresh fruit arrangements from FruitBouquets.com are the perfect gift for a myriad of occasions. Succulent strawberries, the freshest melons, juiciest grapes, sweetest pineapple and brightest oranges are hand-selected and expertly designed into gift baskets and customized shapes to create an unparalleled gift experience that is as thoughtful as it is delicious.',
                href: '/1-800-flowers-home',
            },
        ],
        OurBrandsAboutusTpf: [
            {
                img: 'aboutus_tpf',
                logo: 'tpf',
                description: 'Popcorn has never tasted so good. Delighting the world with popcorn for over 35 years, our innovative flavors provide unforgettable snacking experiences. We infuse our popcorn with great taste and flavor, including real butter, cheddar, caramel, and chocolate. The Popcorn Factory gifts in a variety of exclusively designed tings are perfect for birthdays, congratulations, holidays and so much more. Share the fun!.',
                href: '/1-800-flowers-home',
            },
        ],
        OurBrandsAboutusCheryls: [
            {
                img: 'aboutus_cheryls',
                logo: 'cheryls',
                description: 'For more than 30 years, Cheryl’s has been making our award-winning baked goods with the same level of care you use when baking for family and friends. We select the finest sweet cream butter, the most decadent chocolate, the choicest dried fruits and nuts, the purest vanilla, and the highest quality sugar and honey available, in order to make everything from our brownies to our buttercream the most delicious gift you can send. From our kitchen to yours, enjoy!.',
                href: '/1-800-flowers-home',
            },
        ],
        OurBrandsAboutusBasket: [
            {
                img: 'aboutus_basket',
                logo: 'baskets',
                description: '1-800-Baskets.com has a large selection of expertly designed and thoughtfully crafted gift baskets including fruits, gourmet foods, snacks, candies, and spa and wellness gifts perfect for such occasions as anniversaries, birthdays, housewarmings, new babies, career achievements, sympathy sentiments, and get well wishes.',
                href: '/1-800-flowers-home',
            },
        ],
    },
    seo: {
        seo_searchable: true,
        page_title: 'Our Family of Brands | 1800Flowers',
        meta_description: 'Our Brands',
        keywords: 'family of brands, 1 800 flowers family of brands',
        breadcrumb: [{ title: 'Home', href: '/' }],
        location: { pathname: '/our-family-of-brands' },
    },
};
export default data;
